import { useSearch } from "hooks/useSearch";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { getUserInfoByToken } from "redux/actions/login/loginActions";
import { Box, CircularProgress, Typography } from "@material-ui/core";

// import { sendMsData } from 'redux/actions/login/loginActions';

export const LoadingMS = () => {
  const dispatch = useDispatch();
  const hist = useHistory();
  const { token } = useParams();
  const { setSnackbar } = useSearch();
  useEffect(() => {
    let loading = setTimeout(() => {
      const cToken = JSON.parse(atob(token));
      try {
        if (cToken === "500") {
          setSnackbar("Error de servidor");
          return;
        } else if (cToken === "429") {
          setSnackbar(
            "El url generado ya ha sido usado demasiadas veces; intente generar uno nuevo.",
          );
          return;
        }
        dispatch(getUserInfoByToken(cToken, hist));
      } catch (error) {
        setSnackbar(
          error ? error : "Error de de autentificaciòn, contacte a Soporte",
        );
        hist.replace("/auth/login");
      }
    }, 1000);

    return () => {
      clearTimeout(loading);
    };
  }, []);
  return (
    <Box
      style={{
        flex: 1,
        height: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
        }}
      >
        <CircularProgress style={{ color: "white" }} />
        <Typography variant="caption" component="h5">
          Cargando Datos
        </Typography>
      </Box>
    </Box>
  );
};
